import { change, getFormValues } from 'redux-form'
import { put, select, takeLatest } from 'redux-saga/effects'
import { ISetFieldsVisibility } from '../../../actions/bookingCalendar/reservationModal/fieldVisibility'
import { FormNames } from '../../../containers/Form/CreateReservation'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import { validEmail } from '../../../utils/Validation'

function* clearHiddenInvalidEmail(action: ISetFieldsVisibility) {
  const fieldVisibility = action.value
  if (fieldVisibility.email) return
  const formNames = [FormNames.Create, FormNames.Update]
  for (let i = 0; i < formNames.length; i++) {
    const formName = formNames[i]
    const values = yield select(getFormValues(formName))
    if (!values) continue

    const {
      guest: { email },
    } = values

    if (email && !validEmail(email)) {
      yield put(change(formName, 'guest.email', ''))
    }
  }
}

export default function* () {
  yield takeLatest(
    ReservationModalActions.SetFieldsVisibility,
    clearHiddenInvalidEmail,
  )
}
